export const config = {
  storageKey: "lmh",
  defaultCurrencyCode: "EUR"
}

export default config
